module.exports = __webpack_public_path__ + "assets/img/gal.6ab9f005.jpg";